// @flow

import * as React from 'react';

import style from './ScrollIntoView.module.css';

type Props = {
  children: React.Node,
  /**
   * Controls whether the automatic scroll-into-view behavior triggers upon mounting.
   * When true, the viewport smoothly adjusts using 'nearest' alignment.
   * @default true
   */
  enabled?: boolean,
};

export function ScrollIntoView({
  children,
  enabled = true,
}: Props): React.Node {
  const handleScrollRef = React.useCallback(
    (node: HTMLDivElement | null) => {
      if (!enabled || node === null) return;

      // Loop through all direct visual children and trigger nearest scroll on each
      // (we can't scroll to `node` as it's a non visual wrapper with no dimensions)
      Array.from(node.children).forEach((child: Element) => {
        child.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
        });
      });
    },
    [enabled],
  );

  return (
    <div ref={handleScrollRef} className={style.scrollContainer}>
      {children}
    </div>
  );
}
